export const handlerInitial = {
    isCaseHandler: false,
    isCourtHandler: false,
    caseHandlerName: "",
    courtHandlerName: "",
};